/**
 * ONE COLOR PER ANSWER TO "WHERE IS MY ORDER?", shared by every guest surface
 * that prints a status word — the order page's sentence and the menu's
 * „Comenzile mele" summary. Kept in one module for the same reason the chime
 * lives in ready-alert.ts: two copies would drift, and a state that is olive
 * on one screen and grey on another reads as two different facts.
 *
 * The mapping follows what the guest should FEEL, not the schema:
 *   money still open   → clay, the action color: something is theirs to do;
 *   being worked on    → ink, full strength: alive, nothing to do but wait;
 *   ready              → olive, the celebration color the pickup code turns;
 *   a payment refused  → the danger red, because it needs their eyes;
 *   history            → faint, the quiet grey of things settled.
 */
export function statusTone(status: string): string {
  switch (status) {
    case "awaiting_payment":
    case "unpaid_cash_pending":
      return "var(--color-clay-600)";
    case "paid":
    case "preparing":
      return "var(--color-ink)";
    case "ready":
      return "var(--color-olive-600)";
    case "failed":
      return "var(--color-danger)";
    // handed_over, cancelled, refunded — and any state added later, which
    // should look settled rather than alarming until somebody decides better.
    default:
      return "var(--color-ink-faint)";
  }
}
